import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

// TODO: this component has only visual changes over `design-system/Modal.tsx`.
// Eventually we should converge.
interface ITaskerModalHeaderProps {
  children: React.ReactNode;
}

export function TaskerModalHeader({ children }: ITaskerModalHeaderProps) {
  return (
    <div className="header">
      {children}
      <style jsx>{`
        .header {
          align-items: center;
          color: #000;
          display: flex;
          font-size: 20px;
          font-weight: 600;
          padding: 28.5px;
          text-align: left;
        }
      `}</style>
    </div>
  );
}

interface ITaskerModalHeaderIconProps {
  icon: string;
  color?: string;
}

export function TaskerModalHeaderIcon({ icon, color = '#008EFF' }: ITaskerModalHeaderIconProps) {
  return (
    <div className="header-icon">
      <FontAwesomeIcon icon={icon as IconProp} color={color} />
      <style jsx>{`
        .header-icon {
          font-size: 31px;
          line-height: 31px;
          margin-right: 20.5px;
        }
      `}</style>
    </div>
  );
}

interface ITaskerModalBodyProps {
  children: React.ReactNode;
}

export function TaskerModalBody({ children }: ITaskerModalBodyProps) {
  return (
    <div className="body">
      {children}
      <style jsx>{`
        .body {
          border-top: 1px solid #f1f1f1;
          display: flex;
          padding: 25px;
          color: #000;
          font-weight: 500;
        }
      `}</style>
    </div>
  );
}

interface ITaskerModalFooterProps {
  children: React.ReactNode;
}

export function TaskerModalFooter({ children }: ITaskerModalFooterProps) {
  return (
    <div className="footer">
      {children}
      <style jsx>{`
        .footer {
          border-top: 1px solid #f1f1f1;
          display: flex;
          padding: 25px;
        }
      `}</style>
    </div>
  );
}
